var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostframe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35416"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 261",
    x1: 2,
    y1: 2.5,
    x2: 22,
    y2: 2.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 262",
    x1: 2,
    y1: 9.5,
    x2: 22,
    y2: 9.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 266",
    x1: 2,
    y1: 15.5,
    x2: 22,
    y2: 15.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 263",
    x1: 2,
    y1: 21.5,
    x2: 22,
    y2: 21.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 264",
    x1: 21.5,
    y1: 22,
    x2: 21.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 265",
    x1: 2.5,
    y1: 22,
    x2: 2.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 267",
    x1: 8.5,
    y1: 22,
    x2: 8.5,
    y2: 2,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 268",
    x1: 15.5,
    y1: 22,
    x2: 15.5,
    y2: 2,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostframe);
export default __webpack_public_path__ + "static/media/postframe.e1870cc8945fd9186d83f9d95f70c4ad.svg";
export { ForwardRef as ReactComponent };